module.exports = __webpack_public_path__ + "img/mobile_calender.d6ad724.png";